import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
} from 'Pods/ThreeDStudio/Store/constants'

// Tripo3D retargets onto a named preset clip instead of a numeric library id.
// Its five non-biped presets (quadruped/hexapod/octopod/serpentine/aquatic) are
// omitted: they need a source model rigged with a matching rig_type, and both
// the rig-type control and any non-biped clip are out of the Animate tab.
const ANIMATION_PRESET = [
  'preset:idle',
  'preset:walk',
  'preset:run',
  'preset:dive',
  'preset:climb',
  'preset:jump',
  'preset:slash',
  'preset:shoot',
  'preset:hurt',
  'preset:fall',
  'preset:turn',
]

export default {
  "model_id": MODEL_ID.TRIPO3D_ANIMATION_DEFAULT,
  "provider": PROVIDER.TRIPO3D,
  "action": ACTION.ANIMATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "animation": {
        "type": "string",
        "enum": ANIMATION_PRESET,
      },
    },
    "required": ["input_3d"],
    "additionalProperties": false,
  },
  "ui_schema": {},
  "active_if": {},
}
